

export function getPrimaryUrl(isTeam) {
    if (isTeam === undefined) {
        return "https://production.uclusion.com#signup";
    }
    if (isTeam) {
        return "https://production.uclusion.com/?utm_campaign=team#signup";
    }
    return "https://production.uclusion.com/?utm_campaign=solo#signup";
}

export function getResearchUrl() {
    return "https://production.uclusion.com/?utm_campaign=research#signup";
}